import React, {Component} from 'react';
import Helmet from 'react-helmet';

const initialState = {
  otp: ''
}

class SpecificOtpLogin extends Component {
  state = initialState;

  // 初期表示処理
  componentDidMount() {

    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          this.setState({ otp : otp.code });
        })
        .catch((err) => {
        });
    }

    // 「GA計測用データレイヤースクリプト追加処理」を呼出す
    window.addDataLayerScript('jmbauth_specific_service_otp');

  }

  // [ログイン]ボタン押下時処理
  login = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken;

    // アクションのレポート作成
    try{
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("login_serviceotp", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // 親コンポーネントの共通ログインAPI呼出す処理を呼び出す
    // 引数
    const { otp } = this.state;
    const info={ PWD:otp, ACTION_TOKEN:actionToken };
    // メソッドを呼出す
    this.props.loginMethod(info);
  }

  // 画面入力項目クリア処理
  componentDidUpdate(prevProps) {

    // 現在のエラーマップは前のエラーマップを比較し、更新された場合、画面入力項目をクリアする
    if (this.props.errMap !== prevProps.errMap) {
      // ワンタイムパスワードをクリアする
      this.setState({ otp: '' });
    }
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // Enterキー押下時処理
  handleKeyPress = e => {
      if(e.key === "Enter"){
      e.preventDefault();
      this.login();
    }
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // 画面に表示するメッセージを作成する
    let maskMessage = "";
    if(this.props.maskphonenumber){
      maskMessage = messageList.otpLogin.M016_guideMessage005 + this.props.maskphonenumber + messageList.otpLogin.M017_guideMessage006;
    }else if(this.props.maskmail){
      maskMessage = messageList.otpLogin.M003_guideMessage001 + this.props.maskmail + messageList.otpLogin.M004_guideMessage002;
    }else{
      maskMessage = messageList.otpLogin.M003_guideMessage001 + messageList.otpLogin.M004_guideMessage002;
    }
    const boxStyle = {
      visibility:"hidden",
      width:"1px",
      height:"1px"
    };

    // デザイン定義ファイルを読み込み
    let designJson = require('../jsonFile/design.json');
    // デザイン値をセッションから読み込み
    let design = sessionStorage.getItem('design');

    // JOHNデザインの場合、デザイン値に応じたファイルを設定
    let designFile;
    Object.keys(designJson.otpLogin.I01).forEach(function(data) {
      if (data === design) {
        designFile = require('./design/' + designJson.otpLogin.I01[data]);
      }
    });
    // JALデザインの場合、デフォルトファイルを設定
    if(!designFile){
      designFile = require('./design/' + designJson.otpLogin.I02['default']);
    }

    return(
      <section className="content">
        <Helmet
          title={messageList.otpLogin.M001_browserTitle} >
        </Helmet>

        { // Loadingモーダル表示
          this.props.loading &&
          <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
        }

        {/* 画面タイトル表示部 */}
        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.otpLogin.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          <p className="ds-text">{maskMessage}<br />
            {messageList.otpLogin.M005_guideMessage003}</p>
          <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="ds-textLink ds-textLink--linkBlank u-fw-bold" target="_blank" rel="noopener noreferrer">
            {messageList.otpLogin.M006_guideMessage004}&nbsp;
            <span className="ds-textLink__icon">
              <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.otpLogin.M015_newWindowIcon}>
                <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
              </svg>
            </span>
          </a>

          <div id="JS_error">
          { // エラーメッセージ表示
            (this.props.errMap && this.props.errMap.ERROR) &&
            <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.otpLogin.M007_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.otpLogin.M008_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{this.props.errMap.ERROR}</p>
                </div>
              </div>
            </div>/* /ds-inlineNote */
          }
          </div>

          <div className="formPanel">
            <div className="formPanel__inner">
              <form name="form">

                {/* 画面項目表示部 */}
                {/* ワンタイムパスワード */}
                <div className="formWrap">
                  <label className="formLabel" htmlFor="LB_input-password">
                    <span className="formLabel__text">{messageList.otpLogin.M009_otpPassword}</span>
                  </label>
                  <input type="text" id="LB_input-password"
                    className={ this.props.errMap && this.props.errMap.errorId ==='otp' ? "ds-textfield is-error" :
                    "ds-textfield"}
                    maxLength="6" aria-invalid={ this.props.errMap && this.props.errMap.errorId ==='otp' ? "true" : "false"}
                    aria-describedby="LB_input-password-helper"
                    name="otp" value={this.state.otp} onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress} autoComplete="one-time-code"
                    inputMode="numeric" required />
                  <span className="helperText" id="LB_input-password-helper">{messageList.otpLogin.M019_helperText}</span>
                  {/* 暗黙的Submit抑止用の空inputタグ */}
                  <input type="text" style={boxStyle}/>
                </div>

                {/* 操作ボタン表示部 */}
                <div className="buttonLayout">
                  <div className="buttonWrap buttonWrap--center">
                    <div className="ds-button ds-button--primary ds-button--large">
                      {(design === "JH001N" || design === "JH004N" ) ?
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.login}>
                          <span className="ds-button__label">{messageList.otpLogin.M010_login_john}</span>
                        </button>
                        :
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.login}>
                          <span className="ds-button__label">{messageList.otpLogin.M010_login}</span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* 案内表示部 */}
        {(designFile) && designFile.getDesign(messageList.otpLogin)}

      </section>
    );
  }
}

export default SpecificOtpLogin
